import { render, staticRenderFns } from "./ArticleWeek.vue?vue&type=template&id=342d958c&scoped=true"
import script from "./ArticleWeek.vue?vue&type=script&lang=js"
export * from "./ArticleWeek.vue?vue&type=script&lang=js"
import style0 from "./ArticleWeek.vue?vue&type=style&index=0&id=342d958c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d958c",
  null
  
)

export default component.exports